<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" :model="search_list">
          <el-form-item label="商户编号：">
            <el-select
              class="search-input"
              v-model="search_list.merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银标码分账标识状态：">
            <el-select
              style="width: 150px"
              v-model="search_list.flag"
              placeholder="请选择"
              clearable>
              <el-option value="" label="全部"></el-option>
              <el-option :value="1" label="开启"></el-option>
              <el-option :value="0" label="关闭"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loading"
        :header-cell-style="{background:'#FAFAFA'}"
        :data="status_list">
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="unionShareType"
          label="银标码分账标识状态"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.unionShareType === 1">开启</span>
            <span v-else>关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="edit_status"
              type="text"
              :disabled="scope.row.shareType !== 1"
              :label="scope.row.unionShareType === 0? '开启':'关闭'"
              @click.native="handleEdit(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { listAgentMerchant } from '@/api/transaction'
import { unionRoyaltyList, unionRoyaltyOnOff } from '@/api/machine'
export default {
  name: 'SliverQrcode',
  data () {
    return {
      search_list: {
        merchantId: '',
        flag: '',
        pageNo: 1
      },
      loading: false,
      selectLoading: false,
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      checkLoading: false,
      status_list: [],
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      dataNum: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    /**
             * 商户信息自定义筛选方法
             */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
             * 获取代理商下所有商户列表
             */
    listAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      console.log(params)
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          console.log('listAgentMerchant response:', response)
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
             * 查询
             */
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.search_list.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
             * 点击搜索按钮事件
             */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /**
             * 获取用户信息列表方法
             */
    getList () {
      this.loading = true
      var data = this.formatSearch(this.search_list)
      data = qs.stringify(data)
      unionRoyaltyList(data).then((data) => {
        this.checkLoading = false
        console.log(data)
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.loading = false
        } else {
          this.loading = false
          this.paginations.total = data.totalCount
          this.dataNum = data.totalCount
          this.status_list = data.data
        }
      })
    },
    handleEdit (index, row) {
      var statusText = row.unionShareType === 0 ? '开启' : '关闭'
      var that = this
      this.$confirm('是否确认将商户：' + row.merchantName + ' 的银标码分账标识状态设置为' + statusText + '？', '提示', {}).then(() => {
        var data = {
          merchantId: row.merchantId
        }
        data = qs.stringify(data)
        unionRoyaltyOnOff(data).then((data) => {
          if (parseInt(data.error_code) !== 0) {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
          }
        })
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
             * 改变当前页事件
             * @param  {number} page 当前页码
             */
    onChangeCurrentPage (page) {
      var totalCount = this.dataNum
      var pageSize = this.paginations.pageSize
      this.search_list.pageNo = page
      this.search_list.pageSize = pageSize
      this.search_list.Count = totalCount
      this.getList()
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .btm-action{
        text-align: center;
    }
</style>
